"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XRouteState = exports.XRouteReviewState = void 0;
var XRouteReviewState;
(function (XRouteReviewState) {
    XRouteReviewState["Good"] = "good";
    XRouteReviewState["Bad"] = "bad";
    XRouteReviewState["None"] = "none";
})(XRouteReviewState = exports.XRouteReviewState || (exports.XRouteReviewState = {}));
var XRouteState;
(function (XRouteState) {
    XRouteState["Active"] = "active";
    XRouteState["Staged"] = "staged";
    XRouteState["Disabled"] = "disabled";
})(XRouteState = exports.XRouteState || (exports.XRouteState = {}));
//# sourceMappingURL=xroutes.js.map